export default __webpack_public_path__ + "static/media/closet5-before1-1440w.1c249f07.png";